import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { DiagnosticCodeType } from "@/Common/Models/Patient/Enum/DiagnosticCodeType";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";
import { MedicalItem } from "./MedicalItem";

class MedicalItemProblemAndCondition extends MedicalItem {
    public DateResolved: Date;
    public PrecisionDateProcedure: number;
    public PrecisionDateResolved: number;
    public ProblemDescription: string;
    public Procedure: string;
    public ProcedureDate: Date;
    public AnteriorityConsultationId: string;
    public ProblemStatusLookupId: string;
    public ProblemStatusLookupValue: string;

    public QualifiedDetails: QualifiedDetail[];

    public LifeStageMode: LifeStageModeEnum;
    public LifeStageDate: Date;
    public LifeStagePrecisionDate: LifeStageDatePrecisionEnum;
    public LifeStageAge: number;
    public LifeStageAgeStatusLookupId: string;
    public LifeStageStatusLookupId: string;
    public ForceDisplayInMedicalHistory: boolean;
}

class QualifiedDetail {
    public Id: string;
    public Text: string;
    public StatusLookupId: string;
    public StatusLookupValue: string;
    public Code: string;
    public CodeId: string;
    public Position: number;
    public ProblemItemId: string;
    public SourceDictionary: DiagnosticCodeType;

    public tmpIdForFrontEndOnly: number;
    public isEditMode: boolean;

    public constructor(fields?: Partial<QualifiedDetail>) {
        Object.assign(this, fields);
    }
}

export { MedicalItemProblemAndCondition, QualifiedDetail };
